<template>
  <v-dialog 
  :value="value" 
  @input="$emit('input')" 
  transition="fade-transition" 
  scrollable 
  content-class="creator-community-modal"
  width="1000px">
    <v-card>
      <v-card-title class="card-title-background">
        View Creator Community Form
          <v-spacer></v-spacer>
          <v-btn icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
      </v-card-title>
      <v-card-text class="creator-community-modal__controls">
        <div>
          <v-row class="text-right">
            <v-col class="pb-2" cols="12" sm="12" md="12" lg="12">
              <v-btn color="warning" small @click="changeMode('edit')" v-if="currentMode === 'detail'">
                <v-icon v-on="on" small>edit</v-icon>
                Edit
              </v-btn>
              <v-btn color="error" small @click="changeMode('detail')" v-if="currentMode === 'edit'">
                <v-icon v-on="on" small>close</v-icon>
                Cancel Edit
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-text class="bg-white creator-community-modal__body" v-if="currentMode === 'detail'">
         <v-row>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <label>Name</label>
            <div>{{ (data.name ? data.name : '-') }}</div>
          </v-col>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <label>Email</label>
            <div>{{ (data.email ? data.email : '-') }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <label>Date of Birth</label>
            <div>
              {{data.dateOfBirth ? utils.formatCustomDate(data.dateOfBirth, 'DD/MM/YYYY') : '-'}}
            </div>
          </v-col>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <label>Ethnicity</label>
            <div>{{ (data.ethnicity && data.ethnicity !== 'Others' ? data.ethnicity : '') }}</div>
            <div>{{ (data.otherEth ? data.otherEth : '-') }}</div>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <label>City</label>
            <div>{{ (data.city ? data.city : '-') }}</div>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <label>Country</label>
            <div>{{ (data.country ? data.country : '-') }}</div>
          </v-col>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <label>Gender</label>
            <div>{{ (data.gender ? data.gender : '-') }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <label>Contact Number</label>
            <div>{{ (data.contactNo ? data.contactNo : '-') }}</div>
          </v-col>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <label>Occupation</label>
            <div>
              {{data.occupation || '-'}}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <label>Instagram Handle</label>
            <social-handle
              :isInstagram="true"
              :instagramHandle="data.instagramHandle"
              v-if="data.instagramHandle"
            />
            <div v-if="!data.instagramHandle">-</div>
          </v-col>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <label>Tiktok Handle</label>
            <social-handle
              :isTikTok="true"
              :tiktokHandle="data.tiktokHandle"
              v-if="data.tiktokHandle"
            />
            <div v-if="!data.tiktokHandle">-</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <label>Your IG Followers Count</label>
            <div>{{ (data.igFollowerCount ? data.igFollowerCount : '-') }}</div>
          </v-col>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <label>Your TikTok Followers Count</label>
            <div>{{ (data.tiktokFollowerCount ? data.tiktokFollowerCount : '-') }}</div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6" v-if="data.engagement">
            <label>Engagement</label>
            <div>{{ (data.engagement ? (data.engagement | thousandSeprator) : '-') }}</div>
          </v-col>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6" v-if="data.views">
            <label>Views</label>
            <div>{{ (data.views ? (data.views | thousandSeprator) : '-') }}</div>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <label>IG Average Views</label>
            <div>{{ (data.igAvgViews ? data.igAvgViews : '-') }}</div>
          </v-col>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <label>TikTok Average Views</label>
            <div>{{ (data.tiktokAvgViews ? data.tiktokAvgViews : '-') }}</div>
          </v-col>
        </v-row> -->

        <v-row>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col class="mb-2" cols="12" sm="12" md="12" lg="12">
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Content Type</th>
                        <th class="text-left">Ordinary Rate</th>
                        <th class="text-left">Preferential rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="pl-0">IG Story</td>
                        <td><strong>{{ data.ordinaryRates.igStory || '-'  }}</strong> <span v-if="data.ordinaryRates.igStory">{{ data.ordinaryRates.igStoryCurrency || 'SGD'  }}</span></td>
                        <td><strong>{{ data.preferentialRates.igStory || '-'  }}</strong> <span v-if="data.preferentialRates.igStory">{{ data.preferentialRates.igStoryCurrency || 'SGD'  }}</span></td>
                      </tr>
                      <tr>
                        <td class="pl-0">IG Post</td>
                        <td><strong>{{ data.ordinaryRates.igPost || '-'  }}</strong> <span v-if="data.ordinaryRates.igPost">{{ data.ordinaryRates.igPostCurrency || 'SGD'  }}</span></td>
                        <td><strong>{{ data.preferentialRates.igPost || '-'  }}</strong> <span v-if="data.preferentialRates.igPost">{{ data.preferentialRates.igPostCurrency || 'SGD'  }}</span></td>
                      </tr>
                      <tr>
                        <td class="pl-0">IG Carousel</td>
                        <td><strong>{{ data.ordinaryRates.igCarousel || '-'  }}</strong> <span v-if="data.ordinaryRates.igCarousel">{{ data.ordinaryRates.igCarouselCurrency || 'SGD' }}</span></td>
                        <td><strong>{{ data.preferentialRates.igCarousel || '-'  }}</strong> <span v-if="data.preferentialRates.igCarousel">{{ data.preferentialRates.igCarouselCurrency || 'SGD'  }}</span></td>
                      </tr>
                      <!-- <tr>
                        <td class="pl-0">IG Video</td>
                        <td><strong>{{ data.ordinaryRates.igVideo || '-'  }}</strong> <span v-if="data.ordinaryRates.igVideo">$ SGD</span></td>
                      </tr> -->
                      <tr>
                        <td class="pl-0">IG Reel</td>
                        <td><strong>{{ data.ordinaryRates.igReel || '-'  }}</strong> <span v-if="data.ordinaryRates.igReel">{{ data.ordinaryRates.igReelCurrency || 'SGD' }}</span></td>
                        <td><strong>{{ data.preferentialRates.igReel || '-'  }}</strong> <span v-if="data.preferentialRates.igReel">{{ data.preferentialRates.igReelCurrency || 'SGD'  }}</span></td>
                      </tr>
                      <tr>
                        <td class="pl-0">Loading Fee</td>
                        <td><strong>{{ data.ordinaryRates.loadingFee || '-'  }}</strong> <span v-if="data.ordinaryRates.loadingFee">{{ data.ordinaryRates.loadingFeeCurrency || 'SGD' }}</span></td>
                        <td><strong>{{ data.preferentialRates.loadingFee || '-'  }}</strong> <span v-if="data.preferentialRates.loadingFee">{{ data.preferentialRates.loadingFeeCurrency || 'SGD'  }}</span></td>
                      </tr>
                      <tr>
                        <td class="pl-0">Event Appearance</td>
                        <td><strong>{{ data.ordinaryRates.eventAppearance || '-'  }}</strong> <span v-if="data.ordinaryRates.eventAppearance">{{ data.ordinaryRates.eventAppearanceCurrency || 'SGD' }}</span></td>
                        <td><strong>{{ data.preferentialRates.eventAppearance || '-'  }}</strong> <span v-if="data.preferentialRates.eventAppearance">{{ data.preferentialRates.eventAppearanceCurrency || 'SGD'  }}</span></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <!-- <v-col cols="12" sm="12" md="12" lg="12">
                <label>Remark (Instagram)</label>
                <div v-html="formatDesc(data.igRemarks)"></div>
              </v-col> -->
            </v-row>
            <!-- <v-row>
              <v-col class="d-flex" cols="12" sm="12" md="12" lg="12">
                <label class="mr-2">IG Story</label>
                <div><span v-if="data.igStory">SGD $</span> {{ data.igStory || '-'  }}</div>
              </v-col>
              <v-col class="d-flex" cols="12" sm="12" md="12" lg="12">
                <label class="mr-2">IG Post</label>
                <div><span v-if="data.igPost">SGD $</span> {{ data.igPost || '-'  }}</div>
              </v-col>
              <v-col class="d-flex" cols="12" sm="12" md="12" lg="12">
                <label class="mr-2">IG Carousel</label>
                <div><span v-if="data.igCarousel">SGD $</span> {{ data.igCarousel || '-'  }}</div>
              </v-col>
              <v-col class="d-flex" cols="12" sm="12" md="12" lg="12">
                <label class="mr-2">IG Video</label>
                <div><span v-if="data.igVideo">SGD $</span> {{ data.igVideo || '-'  }}</div>
              </v-col>
              <v-col class="d-flex" cols="12" sm="12" md="12" lg="12">
                <label class="mr-2">IG Reel</label>
                <div><span v-if="data.igReel">SGD $</span> {{ data.igReel || '-'  }}</div>
              </v-col>
              <v-col class="d-flex" cols="12" sm="12" md="12" lg="12">
                <label class="mr-2">Loading Fee</label>
                <div><span v-if="data.loadingFee">SGD $</span> {{ data.loadingFee || '-'  }}</div>
              </v-col>
              <v-col class="d-flex" cols="12" sm="12" md="12" lg="12">
                <label class="mr-2">Event Appearance</label>
                <div><span v-if="data.eventAppearance">SGD $</span> {{ data.eventAppearance || '-'  }}</div>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12">
                <label>Remark</label>
                <div>{{ data.igRemarks || '-'  }}</div>
              </v-col> 
            </v-row> -->
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-row>
              <v-col class="d-flex mb-2" cols="12" sm="12" md="12" lg="12">
                <v-row>
                  <v-col cols="12" sm="12" md="12" lg="12">
                    <v-simple-table class="tiktok-stats" dense>
                      <template v-slot:default>
                        <tbody>
                          <tr>
                            <td class="pl-0">Tiktok</td>
                            <td><strong>{{ data.ordinaryRates.tiktok || '-'  }}</strong> <span v-if="data.ordinaryRates.tiktok">{{ data.ordinaryRates.tiktokCurrency || 'SGD' }}</span></td>
                            <td><strong>{{ data.preferentialRates.tiktok || '-'  }}</strong> <span v-if="data.preferentialRates.tiktok">{{ data.preferentialRates.tiktokCurrency || 'SGD'  }}</span></td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
                <!-- <label class="mr-2">Tiktok</label>
                <div><strong>{{ data.tiktok || '-'  }}</strong> <span v-if="data.tiktok">$ SGD</span></div> -->
              </v-col>
              <!-- <v-col cols="12" sm="12" md="12" lg="12">
                <label>Remark (TikTok)</label>
                <div v-html="formatDesc(data.tiktokRemarks)"></div>
              </v-col> -->
              <v-col cols="12" sm="12" md="12" lg="12">
                <v-divider class="ma-0"></v-divider>
              </v-col>
              <v-col class="mb-2" cols="12" sm="12" md="12" lg="12">
                <label>Handle of Other Platforms</label>
                <v-simple-table dense>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Platform</th>
                        <th class="text-left">URL</th>
                        <th class="text-left">Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr  v-for="(item, index) in data.platforms" :key="index">
                        <td>
                          {{ item.platform }}
                          <span v-if="item.platform === 'others'">{{item.otherPlatform}}</span>
                        </td>
                        <td>{{ item.url }}</td>
                        <td><strong>{{ item.rate }}</strong> <span v-if="item.rate">{{ item.rateCurrency || 'SGD' }}</span></td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col class="mb-2" cols="12" sm="12" md="12" lg="12" v-if="data.pricingDecks && data.pricingDecks.length > 0">
                <label>Media Kit</label>
                <file-preview :files="data.pricingDecks" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col class="mb-2" cols="12" sm="12" md="6" lg="6">
            <div style="text-transform:capitalize;font-weight:bold">{{ (data.type ? data.type : '-') }}</div>
            <div>{{ (data.agencyName ? data.agencyName : '-') }}</div>
          </v-col>
        </v-row> -->
        <v-row>
          <v-col class="mb-2" cols="12" sm="12" md="12" lg="12">
            <label>The Client may be looking to load your content on social media for a duration not more than 30 days, are you agreeable to this arrangement?</label>
            <div>
              {{data.loadContent || '-'}}
            </div>
            <div v-if="data.loadContentText">
              {{data.loadContentText}}
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="mb-2" cols="12" sm="12" md="12" lg="12">
            <label>Would you like to be part of our PR or gifting collaborations with brands?</label>
            <div>
              {{data.giftBrand || '-'}}
            </div>
          </v-col>
        </v-row>
        <v-row v-if="data.keywords">
          <v-col class="mb-2" cols="12" sm="12" md="12" lg="12">
            <label>Preferred type of campaigns/genre (please tick relevant)</label>
            <div>
              <v-chip v-for="(item, index) in data.keywords" :key="index" :value="item"      
                class="ma-2"                               
                filter                                                                                                                                                             
              >
                {{transPreferredEng(item) || '-'}}
              </v-chip>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="data.aboutYou">
          <v-col class="mb-2" cols="12" sm="12" md="12" lg="12">
            <label>A short description of your profile that best represents you</label>
            <div>
              {{data.aboutYou || '-'}}
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <div class="edit-rate-card-form creator-community-modal__body" v-if="currentMode === 'edit'">
        <rate-card-form
          v-model="rateCardDialog"
          :value="rateCardDialog"
          mode="edit"
          :editData="editData"
          @updated="updatedRateCardForm"
        />
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import SocialHandle from '@/components/scoped/custom/SocialHandle';
import FilePreview from '@/components/scoped/custom/FilePreview';
import RateCardForm from './Form';
import influencerHelper from '../influencerHelper'
import utils from '@/utils'
export default {
  name: 'ViewModalDialog',
  components: {
    SocialHandle,
    FilePreview,
    RateCardForm
  },
  props: {
    value: Boolean,
    data: Object,
    rateCardDialog: Boolean
  },
  data () {
    return {
      openExpansion: [0, 1],
      campaignVerticals: [],
      currentMode: 'detail',
      editData: null,
      utils: utils.func
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.currentMode = 'detail'
      }
    }
  },
  methods: {
    close() {
      this.$emit('input');
    },
    changeMode(mode) {
      this.currentMode = mode
      setTimeout(() => {
        this.editData = utils.func.refreshJSON(this.data)
      }, 100)
    },
    updatedRateCardForm() {
      this.close()
      this.$emit('updated')
    },
    formatDesc(text) {
      if (text) {
        return text.replaceAll('\n', '</br>')
      }
      return text
    },
    transPreferredEng(keyword) {
      let categoryEn = influencerHelper.getCategories('en')
      let categoryTh = influencerHelper.getCategories('th')
      let categoryVn = influencerHelper.getCategories('vn')
      let categoryId = influencerHelper.getCategories('id')
      let categoryCn = influencerHelper.getCategories('cn')
      let matchIdx = -1
      matchIdx = categoryTh.findIndex(c => c === keyword)
      if (matchIdx < 0) {
        matchIdx = categoryVn.findIndex(c => c === keyword)
      }
      if (matchIdx < 0) {
        matchIdx = categoryId.findIndex(c => c === keyword)
      }
      if (matchIdx < 0) {
        matchIdx = categoryCn.findIndex(c => c === keyword)
      }
      if (matchIdx >= 0) {
        return categoryEn[matchIdx]
      }
      return keyword
    }
  }
}
</script>
<style>
  .v-application .v-dialog.creator-community-modal > .v-card > .creator-community-modal__controls {
    flex: 0 0 auto;
    min-height: auto;
    overflow: visible;
    padding-top: 1rem;
  }

  .v-application .v-dialog.creator-community-modal > .v-card > .creator-community-modal__body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .tiktok-stats .v-data-table__wrapper {
    border-bottom: 1px solid #e0e0e0;
  }
</style>
<style scoped>
  .card-title-background {
    background-color: #3F3FFF;
  }
  label {
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// ViewModalDialog.vue?8ecd149e